<template>
  <Role :professionalId="id"></Role>
</template>
<script>
import { xray } from "../../../config/pluginInit";

import Role from "../../../components/role/Role";

import utilsService from "../../../services/utils";

export default {
  name: "ProfessionalRole",
  mounted() {
    xray.index();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_ROLES", info: "" });
  },
  computed: {},
  methods: {},
  data() {
    return {
      id: localStorage.getItem("userId"),
    };
  },
  components: {
    Role,
  },
};
</script>
